(function () {
  angular
    .module('kareo.ui.shared.directives.models.insurance-company-plan', [])
    .factory('insuranceCompanyPlan', insuranceCompanyPlan);

  function insuranceCompanyPlan() {
    const plan = {
      customerId: '',
      insuranceCompanyId: '',
      insuranceCompanyPlanId: '',
      planName: '',
      addressLine1: '',
      addressLine2: '',
      city: '',
      state: '',
      zipCode: '',
      phoneNumber: '',
      createdDate: '',
      modifiedDate: '',
      referenced: ''
    };

    const svc = {
      newInsuranceCompanyPlan
    };

    return svc;

    function newInsuranceCompanyPlan() {
      return angular.copy(plan);
    }
  }
})();
